var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "dashboard-editor-container",
    },
    [
      _c(
        "div",
        [
          _c("el-button", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: false,
                expression: "false",
              },
            ],
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.loading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.getAgencyDashboard()
              },
            },
          }),
        ],
        1
      ),
      _c("panel-group", {
        attrs: {
          isFree: _vm.isFree,
          diffDays: _vm.diffDays,
          perYearMemberCount: _vm.perYearMemberCount,
          chatCount: _vm.chatCount,
          recordRequests: _vm.recordRequests,
          travelQtyByOver: _vm.travelQtyByOver,
        },
      }),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.device !== "mobile",
              expression: "device !== 'mobile'",
            },
          ],
          attrs: { gutter: 16 },
        },
        [
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                { staticClass: "chart-wrapper" },
                [
                  _c("line-chart", {
                    attrs: { "chart-data": _vm.lineChartData },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                { staticClass: "chart-wrapper" },
                [
                  _c("bar-chart", {
                    attrs: { weekTourists: _vm.weekTourists },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                {
                  staticClass: "chart-wrapper",
                  staticStyle: { "padding-bottom": "16px" },
                },
                [
                  _c("box-card", {
                    attrs: { surveyAnalysis: _vm.surveyAnalysis },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.device !== "mobile",
              expression: "device !== 'mobile'",
            },
          ],
          attrs: { gutter: 16 },
        },
        [
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                { staticClass: "chart-wrapper" },
                [
                  _c("raddar-chart", {
                    attrs: {
                      travelProperties: _vm.travelProperties,
                      max: _vm.max,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                { staticClass: "chart-wrapper" },
                [
                  _c("pie-chart", {
                    attrs: { travelRegion: _vm.travelRegion },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                {
                  staticClass: "chart-wrapper",
                  staticStyle: { "padding-bottom": "16px", height: "366px" },
                },
                [
                  _c("not-satisfied-box-card", {
                    attrs: { dynamicMaxHeight: "305px" },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.device === "mobile",
              expression: "device === 'mobile'",
            },
          ],
          attrs: { gutter: 16 },
        },
        [
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                {
                  staticClass: "chart-wrapper",
                  staticStyle: { "padding-bottom": "16px" },
                },
                [
                  _c("box-card", {
                    attrs: { surveyAnalysis: _vm.surveyAnalysis },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                {
                  staticClass: "chart-wrapper",
                  staticStyle: { "padding-bottom": "16px", height: "366px" },
                },
                [
                  _c("not-satisfied-box-card", {
                    attrs: { dynamicMaxHeight: "305px" },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                { staticClass: "chart-wrapper" },
                [
                  _c("line-chart", {
                    attrs: { "chart-data": _vm.lineChartData },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.device === "mobile",
              expression: "device === 'mobile'",
            },
          ],
          attrs: { gutter: 16 },
        },
        [
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                { staticClass: "chart-wrapper" },
                [
                  _c("bar-chart", {
                    attrs: { weekTourists: _vm.weekTourists },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                { staticClass: "chart-wrapper" },
                [
                  _c("raddar-chart", {
                    attrs: {
                      travelProperties: _vm.travelProperties,
                      max: _vm.max,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-col",
            {
              staticStyle: { "margin-bottom": "16px" },
              attrs: { xs: 24, sm: 24, md: 24, lg: 8 },
            },
            [
              _c(
                "div",
                { staticClass: "chart-wrapper" },
                [
                  _c("pie-chart", {
                    attrs: { travelRegion: _vm.travelRegion },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }